export default "__VITE_ASSET__fc92c2fa__"